module.exports = __webpack_public_path__ + "static/media/gb.4e0f70a4.svg";